import React, { useEffect,useState } from 'react'
import DayCountDown from '../../components/DayCountDown'
import styled from 'styled-components'
import { useSearchParams } from 'react-router-dom'
import bg from '../../../src/assets/images/pic_bg.png'
import { getProductList } from '../../apis'
import { autoResponse } from '../../utils/utils'
import { freeDaysApi } from '../../apis'
export default function VipInfo() {
  const [searchParams, setSearchParams] = useSearchParams();
  let token = searchParams.get("token")
  const [productList, setProductList] = useState([])
  const [freeDays, setFreeDays] = useState(0)
  const getList = async () => {
    try {
      const res = await getProductList()
      console.log(res.data)
      if(res.data.code === 0){
        setProductList(res.data.data)
      }
    } catch (error) {
      console.log(error)
    }
  }
  const gitFreeInfo = async () => {
    try {
      const res = await freeDaysApi()
      if(res.data.code === 0){
        setFreeDays(res.data.data.days)
      }
    } catch (error) {
      console.log(error)
    }
  }
  useEffect(() => {
    getList()
    gitFreeInfo()
    autoResponse()
    window.addEventListener('resize', autoResponse)

    return () => {
      window.removeEventListener('resize', autoResponse)
    }
  }, [])
  return (
    <Content className='xl:h-full lg:h-full xl:px-0 lg:px-4 md:px-3 h-screen px-3'>
      <Title className='lg:hidden'>Purchase a subscription</Title>
      <DayCountDown/>
      <div className='w-full overflow-x-auto  max-w-[1440px]  md:px-3 lg:px-3 xl:px-3 2xl:px-0 mx-auto'>
          <div className=' flex items-center justify-between min-w-[860px] '>
          <Item className='h-[50rem] lg:h-[42rem]'>
              <div className='text-xl text-[#2E3038] text-left'>Free</div>
              <div className='text-[#2E3038] flex items-end mt-3.5'>
                <span className='text-4xl font-bold'>$0</span>
                <span className='text-xl text-[#808080] ml-1.5 mb-1'>/年</span>
              </div>
              <div className='text-base text-left text-[#2E3038] mt-2'>
                <p>免费版</p>
              </div>
              <Button className='w-full cursor-not-allowed opacity-25 mt-[1.5625rem] mb-[2.125rem] lg:my-5' disabled>订阅</Button>
              <div className='pb-3'>
                <h4 className='mb-1 font-medium text-sm'>节点</h4>
                <div className='flex items-center mt-[9px]'>
                    <Icon src={require('../../assets/images/gou.png')}  alt='icon' />
                    <p className='ml-[9px] text-base'>普通节点</p>
                </div>
                <div className='flex items-center mt-[9px]'>
                    <Icon src={require('../../assets/images/gou.png')}  alt='icon' />
                    <p className='ml-[9px] text-base'>无限速</p>
                </div>
              </div>
              <div className='pb-3'>
                <h4 className='mb-1 font-medium text-sm'>AI Service</h4>
                <div className='flex items-center mt-[9px]'>
                    <Icon src={require('../../assets/images/gou.png')}  alt='icon' />
                    <p className='ml-[9px] text-base'>Chat GPT3（PC Only）</p>
                </div>
              </div>
              <div className='pb-3'>
                <h4 className='mb-1 font-medium text-sm'>IPFS存储</h4>
                <div className='flex items-center mt-[9px]'>
                    <Icon src={require('../../assets/images/gou.png')}  alt='icon' />
                    <p className='ml-[9px] text-base'>IPFS分布式存储（测试版）</p>
                </div>
              </div>
              <div className='pb-3'>
                <h4 className='mb-1 font-medium text-sm'>安全和隐私</h4>
                <div className='flex items-center mt-[9px]'>
                    <Icon src={require('../../assets/images/gou.png')}  alt='icon' />
                    <p className='ml-[9px] text-base'>恶意软件防护</p>
                </div>
                <div className='flex items-center mt-[9px]'>
                    <Icon src={require('../../assets/images/gou.png')}  alt='icon' />
                    <p className='ml-[9px] text-base'>广告拦截</p>
                </div>
                <div className='flex items-center mt-[9px]'>
                    <Icon src={require('../../assets/images/gou.png')}  alt='icon' />
                    <p className='ml-[9px] text-base'>防跟踪</p>
                </div>
                <div className='flex items-center mt-[9px]'>
                    <Icon src={require('../../assets/images/gou.png')}  alt='icon' />
                    <p className='ml-[9px] text-base'>数据泄露扫描</p>
                </div>
              </div>
          </Item>
          <Item className='h-[50rem] lg:h-[42rem]'>
              <div className='text-xl text-[#2E3038] text-left'>VIP0</div>
              <div className='text-[#2E3038] flex items-end mt-3.5'>
                <span className='text-4xl font-bold'>$0</span>
                <span className='text-xl text-[#808080] ml-1.5 mb-1'>/{freeDays}日</span>
              </div>
              <div className='text-base text-left text-[#2E3038] mt-2'>
                <p className=''>体验版</p>
              </div>
              {/* window.location.href = 'https://borderfree.app/download2/' */}
              <Button className='w-full cursor-not-allowed opacity-25 mt-[1.5625rem] mb-[2.125rem] lg:my-5' disabled>订阅</Button>
              <div className='pb-3'>
                <h4 className='mb-1 font-medium text-sm'>节点</h4>
                <div className='flex items-center mt-[9px] lg:mt-[4px]'>
                    <Icon src={require('../../assets/images/gou.png')}  alt='icon' />
                    <p className='ml-[9px] text-base'>普通节点</p>
                </div>
                <div className='flex items-center mt-[9px] lg:mt-[4px]'>
                    <Icon src={require('../../assets/images/gou.png')}  alt='icon' />
                    <p className='ml-[9px] text-base'>快速节点</p>
                </div>
                <div className='flex items-center mt-[9px] lg:mt-[4px]'>
                    <Icon src={require('../../assets/images/gou.png')}  alt='icon' />
                    <p className='ml-[9px] text-base'>无限速</p>
                </div>
              </div>
              <div className='pb-3'>
                <h4 className='mb-1 font-medium text-sm'>AI Service</h4>
                <div className='flex items-center mt-[9px] lg:mt-[4px]'>
                    <Icon src={require('../../assets/images/gou.png')}  alt='icon' />
                    <p className='ml-[9px] text-base'>Chat GPT4（PC Only）</p>
                </div>
                <div className='flex items-center mt-[9px] lg:mt-[4px]'>
                    <Icon src={require('../../assets/images/gou.png')}  alt='icon' />
                    <p className='ml-[9px] text-base'>图片生成（PC Only）</p>
                </div>
                <div className='flex items-center mt-[9px] lg:mt-[4px]'>
                    <Icon src={require('../../assets/images/gou.png')}  alt='icon' />
                    <p className='ml-[9px] text-base'>图片识别（PC Only）</p>
                </div>
              </div>
              <div className='pb-3'>
                <h4 className='mb-1 font-medium text-sm '>IPFS存储</h4>
                <div className='flex items-center mt-[9px] lg:mt-[4px]'>
                    <Icon src={require('../../assets/images/gou.png')}  alt='icon' />
                    <p className='ml-[9px] text-base'>IPFS分布式存储（测试版）</p>
                </div>
              </div>
              <div className='pb-3'>
                <h4 className='mb-1 font-medium text-sm'>安全和隐私</h4>
                <div className='flex items-center mt-[9px] lg:mt-[4px]'>
                    <Icon src={require('../../assets/images/gou.png')}  alt='icon' />
                    <p className='ml-[9px] text-base'>恶意软件防护</p>
                </div>
                <div className='flex items-center mt-[9px] lg:mt-[4px]'>
                    <Icon src={require('../../assets/images/gou.png')}  alt='icon' />
                    <p className='ml-[9px] text-base'>广告拦截</p>
                </div>
                <div className='flex items-center mt-[9px] lg:mt-[4px]'>
                    <Icon src={require('../../assets/images/gou.png')}  alt='icon' />
                    <p className='ml-[9px] text-base'>防跟踪</p>
                </div>
                <div className='flex items-center mt-[9px] lg:mt-[4px]'>
                    <Icon src={require('../../assets/images/gou.png')}  alt='icon' />
                    <p className='ml-[9px] text-base'>数据泄露扫描</p>
                </div>
              </div>
          </Item>
          {
            productList.length > 0 && productList.map((item, index) => {
              return(
                <Item key={item.id} className='h-[50rem] lg:h-[42rem]'>
                <div className='text-xl text-[#2E3038] text-left'>VIP{item.years}</div>
                <div className='text-[#2E3038] flex items-end mt-3.5'>
                  <span className='text-4xl font-bold'>${item.usdtPrice / (item.years * 12) }</span>
                  <span className='text-xl text-[#808080] ml-1.5 mb-1'>/月</span>
                  <span className='text-xl text-[#808080]  mb-1 px-3.5'>或</span>
                  <span className='text-4xl font-bold'>{item.pointPrice / (item.years * 12) }</span>
                  <span className='text-xl text-[#808080] ml-1.5 mb-1'>BFT/月</span>
                </div>
                <div className='text-base text-left text-[#2E3038] mt-2'>
                  <p>按{item.years}年计费</p>
                </div> 
                {/* http://49.212.183.214:8004  http://49.212.213.144:8004/ */}
                <Button className='w-full mt-[1.5625rem] mb-[2.125rem] lg:my-5' onClick={() =>window.location.href = `https://pay.borderfree.app/?id=${item.id}&token=${token}`}>订阅</Button>
                <div className='pb-3'>
                  <h4 className='mb-1 font-medium text-sm'>节点</h4>
                  <div className='flex items-center mt-[9px] lg:mt-[4px]'>
                      <Icon src={require('../../assets/images/gou.png')}  alt='icon' />
                      <p className='ml-[9px] text-base'>普通节点</p>
                  </div>
                  <div className='flex items-center mt-[9px] lg:mt-[4px]'>
                      <Icon src={require('../../assets/images/gou.png')}  alt='icon' />
                      <p className='ml-[9px] text-base'>快速节点</p>
                  </div>
                  <div className='flex items-center mt-[9px] lg:mt-[4px]'>
                      <Icon src={require('../../assets/images/gou.png')}  alt='icon' />
                      <p className='ml-[9px] text-base'>无限速</p>
                  </div>
                </div>
                <div className='pb-3'>
                  <h4 className='mb-1 font-medium text-sm'>AI Service</h4>
                  <div className='flex items-center mt-[9px] lg:mt-[4px]'>
                      <Icon src={require('../../assets/images/gou.png')}  alt='icon' />
                      <p className='ml-[9px] text-base'>Chat GPT4（PC Only）</p>
                  </div>
                  <div className='flex items-center mt-[9px] lg:mt-[4px]'>
                      <Icon src={require('../../assets/images/gou.png')}  alt='icon' />
                      <p className='ml-[9px] text-base'>图片生成（PC Only）</p>
                  </div>
                  <div className='flex items-center mt-[9px] lg:mt-[4px]'>
                      <Icon src={require('../../assets/images/gou.png')}  alt='icon' />
                      <p className='ml-[9px] text-base'>图片识别（PC Only）</p>
                  </div>
                </div>
                <div className='pb-3'>
                  <h4 className='mb-1 font-medium text-sm'>IPFS存储</h4>
                  <div className='flex items-center mt-[9px] lg:mt-[4px]'>
                      <Icon src={require('../../assets/images/gou.png')}  alt='icon' />
                      <p className='ml-[9px] text-base'>IPFS分布式存储（测试版）</p>
                  </div>
                </div>
                <div className='pb-3'>
                  <h4 className='mb-1 font-medium text-sm'>安全和隐私</h4>
                  <div className='flex items-center mt-[9px] lg:mt-[4px]'>
                      <Icon src={require('../../assets/images/gou.png')}  alt='icon' />
                      <p className='ml-[9px] text-base'>恶意软件防护</p>
                  </div>
                  <div className='flex items-center mt-[9px] lg:mt-[4px]'>
                      <Icon src={require('../../assets/images/gou.png')}  alt='icon' />
                      <p className='ml-[9px] text-base'>广告拦截</p>
                  </div>
                  <div className='flex items-center mt-[9px] lg:mt-[4px]'>
                      <Icon src={require('../../assets/images/gou.png')}  alt='icon' />
                      <p className='ml-[9px] text-base'>防跟踪</p>
                  </div>
                  <div className='flex items-center mt-[9px] lg:mt-[4px]'>
                      <Icon src={require('../../assets/images/gou.png')}  alt='icon' />
                      <p className='ml-[9px] text-base'>数据泄露扫描</p>
                  </div>
                </div>
                </Item>
              )
            })
          }
          </div>
      </div>
       
    </Content>
  )
}

const Content = styled.div`
  width: 100%;
  margin: 0 auto;
  background-image: url(${bg});
  background-repeat:no-repeat;
  background-size:100% 100%;
  background-position:center center;
  padding-bottom:1.875rem;
  padding-top:1.375rem;
  /* display: flex;
  justify-content: space-between;
  align-items: center; */
  
`
const Button = styled.button`
    background:#1C58FD;
    height: 2.75rem;
    border-radius: 0.375rem;
    border: 1px solid #1C58FD;
    color: #fff;
    font-size:1rem;
`
const Title = styled.div`
  font-size: 3rem;
  font-weight: 700;
  color: #2E3038;
  margin-bottom: 1.125rem;
`
const Item = styled.div`
  width: 20.375rem;
  padding: 1.6875rem 1.25rem;
  background-color: rgba(255, 255, 255, 0.8);
  border-radius: 1rem;
  text-align: left;
  border: 1px solid transparent;
  &:hover {
    border: 1px solid #1C58FD;
  }
`

const Icon = styled.img `
  width: 0.875rem;
  height: 0.875rem;
`